import { createStyles } from '@material-ui/core/styles';

export default createStyles({
  extendedFieldCnt: {
    '& input': {
      marginRight: '30px'
    }
  }
});
